import ApplicationForm from '@/components/forms/ApplicationForm';

export default function VisualArtists() {
  return (
    <ApplicationForm
      applicationType="visual-artists"
      title="Visual Artists"
      description="Frequency Forest celebrates visual arts in all forms. We're seeking painters, 
        sculptors, installation artists, and creators who want to transform our forest into a 
        magical wonderland."
      showPortfolio={true}
      showExperience={true}
      showRequirements={true}
      showInsurance={true}
      showCertificates={false}
    />
  );
}
